"use client";

import { PAGE_SIZE } from "@knowt/syncing/fetchFunctions/elasticsearch";
import { FlashcardSet, Note } from "@knowt/syncing/graphql/schema";
import SubjectPagePagination from "../components/SubjectPagePagination";
import { FlexColumn } from "@/components/Flex";
import UserContentCard from "@/components/cards/UserContentCard";
import { spacing } from "@/utils/spacing";
import RepeatAutoFillGrid from "@/components/styled/div/RepeatAutoFillGrid";
import { usePublicProfiles } from "@/hooks/user/useUserData";

const SubjectPageContent = ({
    result,
    type,
    searchParams,
}: {
    result: { items: Note[]; total: number } | { items: FlashcardSet[]; total: number };
    type: "flashcards" | "notes";
    searchParams: { pagesize: string };
}) => {
    const isNoteTab = type === "notes";
    const items = type === "flashcards" ? (result.items as FlashcardSet[]).filter(({ draft }) => !draft) : result.items;

    const usersIds = items.map(({ userId }) => userId);
    const { usersData } = usePublicProfiles(usersIds);

    if (!items.length) {
        return <span>No content 🙃</span>;
    }

    const totalPages = Math.ceil(result.total / (+searchParams.pagesize || PAGE_SIZE));

    return (
        <FlexColumn style={{ gap: spacing.LG }}>
            <RepeatAutoFillGrid itemMinWidth="27rem" style={{ gap: spacing.LG }}>
                {items.map((item, i: number) => {
                    const key = isNoteTab ? (item as Note).noteId + i : (item as FlashcardSet).flashcardSetId + i;
                    return (
                        <UserContentCard
                            key={key}
                            {...(isNoteTab ? { note: item as Note } : { flashcardSet: item as FlashcardSet })}
                            ownerDetails={usersData[item.userId]}
                        />
                    );
                })}
            </RepeatAutoFillGrid>

            {/* PAGINATION */}
            {totalPages ? <SubjectPagePagination totalPages={totalPages} /> : null}
        </FlexColumn>
    );
};

export default SubjectPageContent;
